import React from 'react';
import CatalogueCreatedOnListItem from './CatalogueCreatedOnListItem';
import CatalogueUpdatedOnListItem from './CatalogueUpdatedOnListItem';
import CatalogueStatusListItem from '../../status/containers/CatalogueStatusListItem';

const CatalogueFieldListStatusDates = ({ category, code }) => (
  <>
    <CatalogueCreatedOnListItem code={code} category={category} />
    <CatalogueUpdatedOnListItem code={code} category={category} />
    <CatalogueStatusListItem code={code} category={category} />
  </>
);

export default CatalogueFieldListStatusDates;
